import { Table, HStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { RouteProp, useRoute } from '@react-navigation/native';
import { Box } from 'native-base';
import React from 'react';
import { FlatList } from 'react-native';

import { useRecoilQuery } from '../../../../../hooks/useRecoilQuery';
import { SignedInRootStackParamList } from '../../../../../routes/types';
import { customerStrategyDetailsQuery } from '../../../../../store/customerDetail/selector';
import { ItemSeparator } from '../../../../BatchTicket/components/ItemSeparator';
import { DynamicAssetTableProps } from '../../DynamicAsset';
import { LoadingTable, NotFoundTable } from '../_dynamic/constants';
import {
  renderDynamicLoadingFooter,
  renderDynamicTableHead,
  useDynamicTableMaxHeight,
} from '../_dynamic/utils';

import { ProductItem } from './components/ProductItem';
import { consolidatedPositionStrategyEnum, tableHead } from './constants';

export const StrategiesTable: React.FC<DynamicAssetTableProps> = (props) => {
  const { params } = useRoute<RouteProp<SignedInRootStackParamList, 'CustomersAssetsDetails'>>();
  const { data, loading, error, refresher } = useRecoilQuery(
    customerStrategyDetailsQuery({
      accountNumber: params.accountNumber,
      strategyId: consolidatedPositionStrategyEnum[props.product.marketTypeNormalized],
    })
  );

  const maxHeight = useDynamicTableMaxHeight();

  if (loading) {
    return (
      <Box overflow="hidden">
        <Table isLoading={false} cols={tableHead.length} rows={5}>
          {renderDynamicTableHead(tableHead)}
          <LoadingTable columnsItems={tableHead} />
        </Table>
      </Box>
    );
  }

  if (error) {
    return <HStack onTouchMove={refresher} />;
  }

  if (data?.length === 0 && !loading) {
    return <NotFoundTable />;
  }

  const loadingFooter = () => renderDynamicLoadingFooter(loading, tableHead);

  return (
    <Box overflow="hidden">
      <Table isLoading={loading} cols={tableHead.length} rows={5}>
        {renderDynamicTableHead(tableHead)}

        <FlatList
          windowSize={20}
          data={data}
          renderItem={({ item }) => <ProductItem item={item} product={props.product} />}
          keyExtractor={(item) => item.assetNameNormalized.toString()}
          ListFooterComponent={loadingFooter}
          ListFooterComponentStyle={{ paddingVertical: Utils.Token.ToInt(Spacing, 'stack.nano') }}
          maxToRenderPerBatch={10}
          updateCellsBatchingPeriod={50}
          initialNumToRender={10}
          removeClippedSubviews
          showsVerticalScrollIndicator={false}
          ItemSeparatorComponent={ItemSeparator}
          contentContainerStyle={{
            maxHeight,
            paddingBottom: Utils.Token.ToInt(Spacing, 'stack.nano'),
          }}
        />
      </Table>
    </Box>
  );
};
